import { PeriodAggregationEnum } from '@core/types';
import { TreeNode } from 'primeng/api';
import { ISimplifiedNode } from './criteria-summary.types';

/**
 * Simplifies treeNode structure for view
 * @param node TreeNode
 * @returns nodes with only label and children
 */
export const simplifyTreeNode = (node: TreeNode): ISimplifiedNode => {
    // Base case: return the label, and check if children exist to transform them
    const transformedNode: ISimplifiedNode = { label: node.label };

    if (node.children && node.children.length > 0) {
        transformedNode.children = simplifyTreeNodes(node.children);
    }

    return transformedNode;
};

export const simplifyTreeNodes = (nodes: TreeNode[]): ISimplifiedNode[] => {
    return nodes.map(node => simplifyTreeNode(node));
};

/**
 * Returns the label for using in granularity field
 * @param selectedGranularity granularity chosen
 * @returns Label
 */
export const getGranularityName = (selectedGranularity: PeriodAggregationEnum | undefined): string => {
    switch (selectedGranularity) {
        case PeriodAggregationEnum.Year: {
            return 'Years';
        }
        case PeriodAggregationEnum.Quarter: {
            return 'Quarters';
        }
        case PeriodAggregationEnum.Month: {
            return 'Months';
        }
        case PeriodAggregationEnum.Week: {
            return 'Weeks';
        }
        case PeriodAggregationEnum.Day: {
            return 'Days';
        }
    }
    return '';
};

/**
 * Formats granularity name
 * @param value
 * @returns
 */
export const formatGranularityName = (value: PeriodAggregationEnum): string => {
    return value.toString()[0].toUpperCase() + value.toString().slice(1).toLowerCase();
};
